import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m15.133 11.661-5.4-9.333C9.2 1.395 7.933 1.06 7 1.595c-.333.2-.6.466-.733.733l-5.4 9.333c-.534.934-.2 2.2.733 2.734.333.2.667.266 1 .266h10.733c1.134 0 2-.933 2-2 .067-.4-.066-.733-.2-1M8 11.995c-.4 0-.667-.267-.667-.667S7.6 10.66 8 10.66s.667.267.667.667-.267.667-.667.667m.667-3.334c0 .4-.267.667-.667.667s-.667-.267-.667-.667V5.995c0-.4.267-.667.667-.667s.667.266.667.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })